import * as _ from 'lodash';

export const columns: any = [
  {
    title: 'select-all-btn',
    colSize: '5',
    active: false,
    col: 'select-btn'
  },
  {
    title: 'Photo',
    colSize: '4',
    sortable: false,
    sort: 'desc',
    active: false,
    col: 'photo',
    type: 'image'
  },
  {
    title: 'Part no.',
    colSize: '6',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'partNumber'
  },
  {
    title: 'Description',
    colSize: '19',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'description_des_en',
    truncate: true,
    data: (row: any) => {
      return _.get(row, 'descriptions.DES.EN');
    }
  },
];
